import React from 'react';
import { Form, Field } from 'react-final-form';
import { Box } from 'mdlkit';
import { useIntl } from 'react-intl';
import {
  StyledForm,
  FormSubmitLoadingButton,
  StyledFlex,
  FocusShadowInputField,
} from '../shared/Styles';
import DOBField from '../register/PatientForm/DOBField';
import { nameComposed, validateDob } from '../../utils/register/validations';
import { DobType } from '../../interfaces/register';

const validateRecord = (values: DobType) => ({
  ...validateDob(values),
});

interface Props {
  onSubmit: (values: any) => Promise<void>;
}

const AccountRecoveryForm = ({ onSubmit }: Props) => {
  const { formatMessage: f } = useIntl();
  return (
    <Form
      onSubmit={onSubmit}
      validate={validateRecord}
      render={({
        handleSubmit,
        submitting,
        hasValidationErrors,
        hasSubmitErrors,
        dirtySinceLastSubmit,
      }) => (
        <StyledForm onSubmit={handleSubmit} spellCheck={false}>
          <StyledFlex>
            <Box>
              <Field
                id="firstName"
                label={f({ id: 'firstName' })}
                name="firstName"
                validate={nameComposed}
                component={FocusShadowInputField}
                autoCorrect="off"
                spellCheck={false}
                maxLength={35}
              />
            </Box>
            <Box>
              <Field
                id="lastName"
                label={f({ id: 'lastName' })}
                name="lastName"
                validate={nameComposed}
                component={FocusShadowInputField}
                autoCorrect="off"
                spellCheck={false}
                maxLength={35}
              />
            </Box>
          </StyledFlex>
          <DOBField />
          <FormSubmitLoadingButton
            id="accountRecoveryBtn"
            type="submit"
            size="large"
            disabled={
              submitting ||
              hasValidationErrors ||
              (hasSubmitErrors && !dirtySinceLastSubmit)
            }
            isLoading={submitting}
          >
            Continue
          </FormSubmitLoadingButton>
        </StyledForm>
      )}
    />
  );
};

export default AccountRecoveryForm;
